import { useEffect } from "react";
import "./Map.scss"

export default function Map({...props}) {

  // useEffect()

  function convertYandexMapsUrl(url: string) {
    url = url.replace('/maps/', '/map-widget/v1/')

    if (!url.includes("&theme")) {
      const prefx =  url.includes('?')? '&': '?'
      url+=prefx + 'theme=dark'
    }
    return url;
  }

  const place = convertYandexMapsUrl(`https://yandex.ru/maps/2/saint-petersburg/?ll=${props.coordinates.longitude}%2C${props.coordinates.latitude}&pt=${props.coordinates.longitude}%2C${props.coordinates.latitude}&z=18.08`)
  

  return (
    // <div 
    // style="position:relative;overflow:hidden;">
    //   <a href="https://yandex.ru/maps/org/pesets/138845503419/?utm_medium=mapframe&utm_source=maps"
    //   style="color:#eee;font-size:12px;position:absolute;top:0px;">
    //     Песец</a>
    //     <a href="https://yandex.ru/maps/2/saint-petersburg/category/strikeball/23663725205/?utm_medium=mapframe&utm_source=maps" 
    //     style="color:#eee;font-size:12px;position:absolute;top:14px;">Страйкбол в Санкт‑Петербурге</a>
    //     <a href="https://yandex.ru/maps/2/saint-petersburg/category/hydroball/174851705522/?utm_medium=mapframe&utm_source=maps" 
    //     style="color:#eee;font-size:12px;position:absolute;top:28px;">Гидробол в Санкт‑Петербурге</a>
    <>
        <iframe src={place} className={'customMap '+ (props.className || '')} title="Карта полигона"></iframe>
    </>
    // <iframe
    //   src="https://yandex.ru/map-widget/v1/?um=constructor%3A6a0050bcc849cff501df47fdfada797b569897de6eb47f5b7178c521021081ab&amp;source=constructor&theme=dark" 
    //   width="500" height="400" 
    //   style = {{borderRadius:20, filter:""}}
    // >

    // </iframe>
  )
}
